import {
  FavoritedContentContext,
  FavoritedContentConsumer,
  FavoritedContentProvider
} from './favorited-content-context';

export { FavoritedContentContext, FavoritedContentConsumer, FavoritedContentProvider };

export default FavoritedContentContext;
